import { getItemFromStore } from './utils';
const toGBP = value => {
  return value.toLocaleString('en-UK', {
    style: 'currency',
    currency: 'GBP'
  });
};

const targetTypeKey = 'balance.score.card.targettype';

const defaultFormatTime = 'YYYY-MM-DD HH:mm:ss';

const formatNumber = str => {
  const number = Number(str);
  if (!isNaN(number)) {
    return number.toLocaleString('en-GB');
  } else {
    return str;
  }
};

const buildTargetTextDisplay = (typeValue, data, targetType, numOfDecimal=0) => {
  const formatNumber = getTargetDecimal(targetType,numOfDecimal);
  if (!data) {
    if (!typeValue) {
      return 'TBC';
    }
    return typeValue;
  }

  let numericData = data;
  if (typeof data === 'string') {
    numericData = parseFloat(data.replace(/,/g, ''));
    if (isNaN(numericData)) {
      console.log('Invalid data format:', data);
      return ''; //
    }
  }

  const formattedData = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: formatNumber,
    maximumFractionDigits: formatNumber
  }).format(numericData);

  if (!typeValue) {
    return formattedData;
  }

  if (typeValue === '£') {
    return typeValue + ' ' + formattedData;
  }
  if (typeValue === '%') {
    return formattedData + ' ' + typeValue;
  }
  return formattedData + ' ' + typeValue;
};

const isTargetUseDecimal = (targetType) => {
  const targetTypes = getItemFromStore(targetTypeKey, [], sessionStorage);
  return (
    targetTypes?.find(x => x.id == targetType)?.name == 'Number' ||
    targetTypes?.find(x => x.id == targetType)?.name == 'Percentage'
  );
};

const getTargetDecimal = (targetType, noOfDecimal) => {
  const numOfDecimal = isTargetUseDecimal(targetType) ? noOfDecimal : 0;
  return numOfDecimal;
}

export {
  toGBP,
  buildTargetTextDisplay,
  formatNumber,
  defaultFormatTime,
  targetTypeKey,
  isTargetUseDecimal,
  getTargetDecimal
};
